import { render, staticRenderFns } from "./releasePolicyDeclare.vue?vue&type=template&id=917a304e&scoped=true&"
import script from "./releasePolicyDeclare.vue?vue&type=script&lang=js&"
export * from "./releasePolicyDeclare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917a304e",
  null
  
)

export default component.exports